@let isCODEMethod = methodCtrl.value === withdrawalMethodIdEnum.CODEOffice;

<ng-container [formGroup]="withdrawalForm">
  <div class="account-controls">
    <iw-account-with-amount-select
      [skipTouch]="true"
      [isAccountSender]="true"
      [shouldPreselect]="true"
      [accounts]="accounts"
      [class.curved-bottom]="isCODEMethod"
      formControlName="walletAndAmountFrom"
      [defaultCurrency]="defaultCurrency()"
      listLabel="withdrawal.dialog.accountSelect.listLabel"
      [hostAmountError]="
        !walletAndAmountFromCtrl.disabled ? withAmountCtrlError() : null
      "
      [placeholder]="
        isDesktop()
          ? 'withdrawal.dialog.accountSelect.placeholder'
          : 'withdrawal.dialog.title'
      "
    />

    @if (isCODEMethod) {
      <iw-account-with-amount-select
        class="curved-top"
        [skipTouch]="true"
        [shouldPreselect]="true"
        [accounts]="availableCurrencies()"
        formControlName="walletAndAmountTo"
        [hostAmountError]="withAmountCtrlError()"
        [disabledAccountId]="walletAndAmountToCtrl.value?.account.id"
        [placeholder]="
          isDesktop()
            ? 'withdrawal.dialog.accountSelect.CODEOffice.placeholder'
            : 'withdrawal.dialog.accountSelect.CODEOffice.placeholder.mobile'
        "
      />

      <div class="pointer">
        <fu-icon
          class="pointer-icon"
          iconName="arrow-down"
          [size]="isDesktop() ? 24 : 16"
        />
      </div>
    }
  </div>

  @if (!isConfirmationStep()) {
    @if (methodsByCurrency()) {
      <div class="details-form section">
        @if (methodCtrl.value !== withdrawalMethodIdEnum.Crypto) {
          <fu-select
            formControlName="method"
            [placeholder]="
              'withdrawal.dialog.methodSelect.placeholder' | translate
            "
            [items]="methodsByCurrency()"
            nameField="key"
            [label]="'withdrawal.dialog.methodSelect.label' | translate"
            [useOutlineLabel]="false"
            [errorDictionary]="methodErrorDictionary()"
            activeItemIcon="checkmark"
          />
        }

        @if (methodCtrl.value) {
          <iw-apm-form
            [method]="methodCtrl.value"
            [form]="apmDetailsForm"
          ></iw-apm-form>
        }
      </div>
    }
  } @else {
    <iw-withdrawal-details
      [withdrawalInfo]="withdrawalReq()"
      [currencyFrom]="walletAndAmountFromCtrl.value?.account.currency"
      [currencyTo]="walletAndAmountToCtrl.value?.account.currency"
    />
  }
</ng-container>

@if (methodsByCurrency()) {
  <div class="actions">
    @if (!isConfirmationStep()) {
      @if (isDesktop()) {
        <iw-button
          size="m"
          fullWidth
          class="action"
          uiType="secondary"
          (click)="closeDialog()"
        >
          {{ "withdrawal.dialog.actions.cancel" | translate }}
        </iw-button>
      }
      <iw-button
        size="m"
        fullWidth
        class="action"
        uiType="primary"
        [disabled]="withdrawalForm.invalid || withAmountCtrlError()"
        (click)="next()"
      >
        {{ "withdrawal.dialog.actions.next" | translate }}
      </iw-button>
    } @else {
      @if (isDesktop()) {
        <iw-button
          size="m"
          fullWidth
          class="action"
          uiType="secondary"
          (click)="back()"
        >
          {{ "withdrawal.dialog.actions.back" | translate }}
        </iw-button>
      }
      <iw-button
        size="m"
        fullWidth
        class="action"
        uiType="primary"
        (click)="confirm()"
        [disabled]="feeLoading()"
      >
        {{ "withdrawal.dialog.actions.confirm" | translate }}
      </iw-button>
    }
  </div>
}

@if (isDesktop()) {
  <div class="support-note">
    <fu-icon iconName="information-circle" size="16" />
    <div class="text">
      {{ "withdrawal.dialog.support.text" | translate }}
      <a
        class="link"
        [href]="supportLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "withdrawal.dialog.support.link" | translate }}
      </a>
    </div>
  </div>
}
